<div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
    Filter
</div>

<div class="flex-content">
    <tyl-form-field style="margin-left:10px; width: 93%" label='Default Display'>
        <mat-select id="dropdownDefaultDisplay" aria-label="Graduation plans default display" tabindex="0"
            [(ngModel)]="gpFilterParam.DefaultDisplay" (ngModelChange)="filterChangeByModel();">
            <!--<mat-option value="PT">Plan Type</mat-option>-->
            <!--<mat-option value="PT|GP">Plan Type > Graduation Plan</mat-option>-->
            <!--<mat-option value="PT|GP|SA">Plan Type > Graduation Plan > Subject Area</mat-option>-->
            <!--<mat-option value="PT|GP|SA|CC">Plan Type > Graduation Plan > Subject Area > Credit Codes</mat-option>-->
            <!--<mat-option value="PT|GP|SA|CC|CR">Plan Type > Graduation Plan > Subject Area > Credit Codes > Courses </mat-option>-->
            <mat-option value="GP" translate>Graduation Plan</mat-option>
            <mat-option value="GP|SA" translate>Graduation Plan > Subject Area</mat-option>
            <mat-option value="GP|SA|CC" translate>Graduation Plan > Subject Area > Credit Codes</mat-option>
            <mat-option value="GP|SA|CC|CR" translate>Graduation Plan > Subject Area > Credit Codes > Courses
            </mat-option>
        </mat-select>
    </tyl-form-field>

    <tyl-form-field style="margin-left:10px; width: 93%" label='Credit Decimal'>
        <mat-select id="dropdownCreditDecimal" aria-label="Credit Decimal" tabindex="1"
            [(ngModel)]="gpFilterParam.CreditDecimalPrecision" (ngModelChange)="filterChangeByModel();">
            <mat-option [value]="0">0</mat-option>
            <mat-option [value]="1">1</mat-option>
            <mat-option [value]="2">2</mat-option>
            <mat-option [value]="3">3</mat-option>
            <mat-option [value]="4">4</mat-option>
        </mat-select>
    </tyl-form-field>

    <!--<tyl-multiple-select-list-->
    <!--style="margin-left:10px;" selectWidth = "93%"            -->
    <!--aria-label="Plan Type Filter"-->
    <!--id="dropdownPlanType"-->
    <!--tabindex="2" -->
    <!--label="Plan Type"-->
    <!--[dataSource] = 'graduationPlanTypes'-->
    <!--displayField = 'Code'-->
    <!--valueField = 'Code'-->
    <!--valueFieldType ='string'-->
    <!--[(selected)] = 'gpFilterParam.PlanType'-->
    <!--(selectedChange) = "filterChangeByModel();"-->
    <!--&gt;-->
    <!--</tyl-multiple-select-list>    -->

    <tyl-multiple-select-list style="margin-left:10px;" selectWidth="93%"
        aria-label="Grade Plan Completion Status Filter" id="dropdownGradPlanCompletionStatus" tabindex="3"
        label="Grad Plan Completion Status" [dataSource]="['Complete', 'Incomplete']"
        [(selected)]='gpFilterParam.GradPlanStatus' (selectedChange)="filterChangeByModel();">
    </tyl-multiple-select-list>

    <tyl-multiple-select-list style="margin-left:10px;" selectWidth="93%"
        aria-label="Subject Area Completion Status Filter" id="dropdownSubjectAreaCompletionStatus" tabindex="4"
        label="Subject Area Completion Status" [dataSource]="['Complete', 'Incomplete']"
        [(selected)]='gpFilterParam.SubjectAreaStatus' (selectedChange)="filterChangeByModel();">
    </tyl-multiple-select-list>

    <tyl-multiple-select-list style="margin-left:10px;" selectWidth="93%"
        aria-label="Credit Code Completion Status Filter" id="dropdownCreditCodeCompletionStatus" tabindex="5"
        label="Credit Code Completion Status" [dataSource]="['Complete', 'Incomplete']"
        [(selected)]='gpFilterParam.CreditCodeStatus' (selectedChange)="filterChangeByModel();">
    </tyl-multiple-select-list>

    <!--<tyl-form-field label="Needed less than or equal to " style="margin-left:10px; width: 93%">-->
    <!--<input title="Decimal Credit" style="margin-left:3px; width:98%;"-->
    <!--id="txtGradPlanNeeded" -->
    <!--matInput -->
    <!--aria-label="Graduation Plans with Needed less than or equal to"-->
    <!--tabindex="6"-->
    <!--[(ngModel)]="gpFilterParam.GPNeeded" -->
    <!--(ngModelChange)="filterChangeByModel();" />-->
    <!--</tyl-form-field>       -->


    <tyl-multiple-select-list style="margin-left:10px;" selectWidth="93%" aria-label="Course Completion Status Filter"
        id="dropdownCourseCompletionStatus" tabindex="5" label="Course Completion Status"
        [dataSource]="['Complete', 'Incomplete']" [(selected)]='gpFilterParam.CourseStatus'
        (selectedChange)="filterChangeByModel();">
    </tyl-multiple-select-list>
</div>

<div class="filter-flex-footer">
    <!-- Left Buttons -->
    <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

    <!-- Right Buttons -->
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
    </div>
</div>